import React from 'react';
import AboutMain from './AboutMain';
import Footer from '../../components/Footer';
import HeaderSeven from '../../components/Header/HeaderSeven';
import HeaderFive from '../../components/Header/HeaderFive';
import FooterThree from '../../components/Footer/FooterThree';

const About = () => {
  return (
    <>
      <HeaderFive />

      <AboutMain />

      <FooterThree />
    </>
  );
};

export default About;
